import {WeatherInfo} from '../../../widgets/WeatherInfo';
import {WeatherBlocks, WeatherContainer, WeatherWrapper} from './styles.ts';
import {WeatherSchedule} from '../../../widgets/WeatherSchedule';
import {Segmented} from '../../../shared/ui/Segmented/Segmented.tsx';
import React, {useEffect, useMemo, useState} from 'react';
import Loader from '@atomaro/ui-kit/components/Loader/Loader';
import {useWeatherStore} from 'entities/weather/index.ts';
import {useBreadcrumbsStore} from 'entities/breadcrumbs/index.ts';
import {makeDays} from 'widgets/WeatherCalendar/lib/makeDays.ts';
import {WeatherCalendar} from 'widgets/WeatherCalendar/index.ts';
import {useApiariesStore} from '../../../entities/apiaries';
import {AbsenceText} from '../../../shared/ui/absenceText/AbsenceText.tsx';

export const WeatherPage = () => {
  const [active, setActive] = useState<'10' | 'month' | string>('10');

  const setBreadcrumbs = useBreadcrumbsStore((s) => s.setCrumbs);
  const refreshForecast: () => void = useWeatherStore((s) => s.refreshForecast);
  const scheduleRows = useWeatherStore((s) => s.scheduleRows);
  const factForecast = useWeatherStore((s) => s.factForecast);
  const weather = useWeatherStore((s) => s.weatherMapCalendar);
  const currentApiaryId = useApiariesStore((s) => s.currentApiaryId);
  const setIsCreateApiaryOpen = useApiariesStore((s) => s.setIsModalOpen);

  const calendarDays = useMemo(() => {
    return makeDays(30, weather);
  }, [weather]);

  useEffect(() => {
    setBreadcrumbs([
      {title: 'Моя пасека', url: '/', route: {path: '/'}},
      {
        title: 'Погода на пасеке',
        url: '/weather',
        route: {path: '/weather'},
      },
    ]);
  }, [setBreadcrumbs]);

  useEffect(() => {
    refreshForecast();
  }, [refreshForecast]);

  if (!currentApiaryId) {
    return (
      <AbsenceText
        text={'Добавьте пасеку'}
        subText={'Начните с добавления Вашей первой пасеки для начала работы с приложением'}
        buttonText={'Добавить пасеку'}
        onClick={() => setIsCreateApiaryOpen(true)}
      />
    );
  }
  if (!scheduleRows || !factForecast || !weather) return <Loader size={'m'} />;

  return (
    <WeatherContainer>
      <WeatherWrapper>
        <WeatherInfo forecast={factForecast} />

        <Segmented
          value={active}
          onChange={setActive}
          options={[
            {value: '10', label: 'На 10 дней'},
            {value: 'month', label: 'На месяц'},
          ]}
        />

        {active === 'month' && <WeatherCalendar days={calendarDays} />}
        {active === '10' && (
          <WeatherBlocks>
            {scheduleRows.map((row, ind) => (
              <WeatherSchedule row={row} key={ind} />
            ))}
          </WeatherBlocks>
        )}
      </WeatherWrapper>
    </WeatherContainer>
  );
};
